import React, { useEffect, useState } from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';

const FiltersPartial = (props) => {
  const { filtersModel, setFiltersModel } = props;
  const [branchesApi] = getApi('branches');
  const [branches, setBranches] = useState([])
  const [selectedBranches, setSelectedBranches] = useState([])


  useEffect(()=>{
    fetchBranches();
  },[])

  useEffect(()=>{
    const set1 = new Set(filtersModel.branch_ids || []);
    setSelectedBranches((prevState)=>{
      return branches.filter((branch)=>set1.has(branch.id))
    })
  },[filtersModel])

  const fetchBranches = async () => {
    try {
      const response = await branchesApi({fields: "options"}).unwrap();
      setBranches(response.data.branches);
    } catch (error) {
    }
  }

  const onStatusAdded = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, status: [...(prevState.status || []), selectedOption.id] }
    })
  }

  const onStatusRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, status: prevState.status.filter((id) => id !== removedOption.id) }
    })
  }


  const onBranchAdded = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, branch_ids: [...(prevState.branch_ids || []), selectedOption.id] }
    })

    setSelectedBranches((prevState) => {
      return [...(prevState || []), selectedOption] 
    })
  }

  const onBranchRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, branch_ids: prevState.branch_ids.filter((id) => id !== removedOption.id) }
    })

    setSelectedBranches((prevState) => {
      return prevState.filter((branch)=> branch.id != removedOption.id)
    })
  }

  return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
    <Form.Group className="mb-3">
      <Form.Label>Status</Form.Label>
      <MultiSelectField
        options={[
          {
            id: 'requested',
            name: 'Requested'
          },
          {
            id: 'finalized',
            name: 'Finalized'
          },
          {
            id: 'cancelled',
            name: 'Cancelled'
          },
          {
            id: 'completed',
            name: 'Completed'
          },
          {
            id: 'pipeline',
            name: 'Pipeline'
          },
        ]}
        fieldName="status"
        stateModel={filtersModel}
        labelAttr="name"
        valueAttr="id"
        displayValue="name"
        onSelect={onStatusAdded}
        onRemove={onStatusRemove}
      />
      <br/>
      <Form.Label>Circles</Form.Label>
          <Multiselect
            id='branch_ids'
            selectedValues={selectedBranches}
            options={branches}
            onSelect={onBranchAdded}
            onRemove={onBranchRemove}
            placeholder='Select Circles'
            displayValue={'name'}
            showArrow={true}
            customArrow={true}
            avoidHighlightFirstOption={true}
          />
    </Form.Group>
  </Filters>
};

export default FiltersPartial;

